import React from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import { useNavigate } from "react-router";
import { LOGIN_PAGE } from "../../routes";
import { useTranslation } from "react-i18next";

const RegistrationSuccess: React.FC = () => {
  const isDesktop = useDesktopSize();
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <div className={isDesktop ? "login-wrapper" : "login-wrapper-mobile"}>
      <div className={isDesktop ? "login-panel" : "login-panel-mobile"}>
        <h3 className={"registration-panel-title"}>{t("konto_zostalo_pomyslnie_zalozone")}</h3>
        <p className={"registration-panel-section-1"}>{t("dziekujemy_za_zalozenie_konta")}</p>
        <div className={"div-buttons"} style={{ justifyContent: "center" }}>
          <button className={"login-button"} onClick={() => navigate(LOGIN_PAGE)}>
            {t("zaloguj_sie")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
